<div class="col-xs-12" ng-show="funcoes">
  <div class="panel panel-default">
    <div class="panel-heading">Resultados</div>
    <div class="panel-body">
      <small ng-show="funcoes.length == 0">Nenhum resultado encontrado!</small>
      <table class="table table-hover table-striped" ng-show="funcoes.length > 0">
        <thead>
          <tr>
            <th class="col-xs-11">Descricao</th>
            <th class="col-xs-1"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="funcao in funcoes track by $index">
            <td class="vertical-middle">{{funcao.descricao | humanize}}</td>
            <td class="vertical-middle text-right">
              <div class="btn btn-primary btn-sm" ng-click="show($index)" uib-tooltip="Visualizar" tooltip-placement="top">
                <i class="glyphicon glyphicon-eye-open"></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-right">
        <ng-include src="'views/_pagination.html'"></ng-include>
      </div>
    </div>
  </div>
</div>